import React from 'react'
import PageWrapper from '../PageWrapper/PageWrapper'
import Button from '../Button/Button'
import InfoPack from '../AboutPage/InfoPack.pdf'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faDownload } from '@fortawesome/free-solid-svg-icons'
import './FeesPage.css'

const FeesPage = () => {
  return (
    <PageWrapper title='Fees'>
      {/* Class Fees Section */}
      <section className='fees-section'>
        <h2 className='fees-section-title'>Class Fees</h2>
        <div className='fees-grid'>
          <div className='fee-card'>
            <div className='fee-duration'>30 min lesson</div>
            <div className='fee-amount'>$13</div>
          </div>
          <div className='fee-card'>
            <div className='fee-duration'>45 min lesson</div>
            <div className='fee-amount'>$17</div>
          </div>
          <div className='fee-card'>
            <div className='fee-duration'>1 hour lesson</div>
            <div className='fee-amount'>$21</div>
          </div>
        </div>
      </section>

      {/* Private Lessons Section */}
      <section className='fees-section'>
        <h2 className='fees-section-title'>Private Lessons</h2>
        <div className='fees-grid'>
          <div className='fee-card'>
            <div className='fee-duration'>Solo Private Lesson</div>
            <div className='fee-detail'>(30 min)</div>
            <div className='fee-amount'>$38 pp.</div>
          </div>
          <div className='fee-card'>
            <div className='fee-duration'>Duo Private Lesson</div>
            <div className='fee-detail'>(30 min)</div>
            <div className='fee-amount'>$28 pp.</div>
          </div>
          <div className='fee-card'>
            <div className='fee-duration'>Trio Private Lesson</div>
            <div className='fee-detail'>(30 min)</div>
            <div className='fee-amount'>$20 pp.</div>
          </div>
        </div>
      </section>

      {/* Annual Registration Section */}
      <section className='fees-section'>
        <h2 className='fees-section-title'>Annual Registration</h2>
        <p className='fees-section-subtitle'>(admin, insurances & licensing etc)</p>
        <div className='fees-grid'>
          <div className='fee-card'>
            <div className='fee-duration'>Students aged 2-5 yrs</div>
            <div className='fee-amount'>$40 pp.</div>
          </div>
          <div className='fee-card'>
            <div className='fee-duration'>Kindergarten +</div>
            <div className='fee-amount'>$60 pp.</div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className='fees-cta-section'>
        <h3 className='fees-cta-title'>Class Packages & Special Discounts</h3>
        <p className='fees-cta-text'>Download our information pack for details on class packages with special discounts.</p>
        <a href={InfoPack} download className='fees-download-link'>
          <FontAwesomeIcon icon={faDownload} />
          <span>Download 2026 Information Pack</span>
        </a>
      </section>

      {/* Important Information Section */}
      <section className='fees-info-section'>
        <h2 className='fees-section-title'>Important Information</h2>
        <div className='fees-info-content'>
          <div className='fees-info-item'>
            <p><strong>Fees are charged per school term.</strong></p>
          </div>
          <div className='fees-info-item'>
            <p>No refunds for classes that fall on Public Holidays.</p>
          </div>
          <div className='fees-info-item'>
            <p>Term fees must be paid in full within 3 weeks of invoice.</p>
          </div>
          <div className='fees-info-item'>
            <p>Late fees apply, as stipulated in our 2026 Dance Policies.</p>
          </div>
          <div className='fees-info-item'>
            <p><strong>Special circumstances:</strong> If your child has a severe injury or illness, we will offer you a credit towards your dance account for future fees.</p>
          </div>
          <div className='fees-info-item'>
            <p>If you have a holiday planned in advance, please let us know prior to term fees being invoiced and we can adjust accordingly.</p>
          </div>
          <div className='fees-info-item'>
            <p>All other missed lessons must be paid for.</p>
          </div>
        </div>
      </section>
    </PageWrapper>
  )
}

export default FeesPage
